document.addEventListener('crJQActivated', function (e) {
    
        // Remove pickup and refresh the page if only the pickup item is in the cart
        var productData = {quantity: 0,id: pickupProduct};

        jqCR.getJSON('/cart', function(e){
            var items = e.items;
          	console.log(items.length)
            for (var i in items) {
                if(items.length === 1 && String(items[i].id) === pickupProduct) {
                    jqCR.post('/cart/change.js', productData, function() {
                        console.log('refresh');
                        if (pickupProduct) {
                            location.reload();
                        }

                    }, 'json')
                }
            }
        })

})
var CRskipUpdateFormAction = true;
// $(document).ready(function() {
//   $('body').on('click', 'input[name="checkout"]', function(e){
//   	if ($('#pickup-details').length) {
//    		e.preventDefault();
//         var myForm = $('#pickup-details').closest('form')

// 	    if ($('#pickup-container').is(":visible")
//             && $('.pickup-button').hasClass('selected')
//             && $('.activeStore').attr('id') === undefined
//             && stores !== undefined
//             && stores.length > 1
//         ) {
//             $('#pickup-store-search').val('')
//             $('#pickup-store-search-error').remove()
//             setTimeout(function(){
//                 $('#storeUL').after('<label id="pickup-store-search-error" class="error" for="storeUL">' + pickupTranslations.en.storeSelectError + '</label>');
//                 $('#pickup-store-search-error').css('display', 'block');    
//             }, 100)
            
//         } else {
//             $('#pickup-store-search-error').remove();
//         }
	    
// 	    var pickupFirstName = '';
// 	    var pickupLastName = '';
	    
// 	  	var shippingInformation = storePickup.shippingInformation + 'test'
// 	    //storePickup.updateFormActionWithShippingInformation();
	    
// 	    var action = myForm.attr('action');      	      
	    
// 	    var pivot = action.replace(/checkout\\[shipping_address\\]\\[first_name\\](.*?)\\&/ig, '');
// 	  	shippingInformation = pivot + "&checkout[shipping_address][first_name]=" + pickupFirstName;
	  	
// 	    pivot = shippingInformation.replace(/checkout\\[shipping_address\\]\\[last_name\\](.*?)\\&/ig, '');      	
// 	    shippingInformation = pivot + "&checkout[shipping_address][last_name]=" + pickupLastName + '&';
        
//         pivot = shippingInformation.replace(/checkout\\[shipping_address\\]\\[city\\](.*?)\\&/ig, '');      	
// 	    shippingInformation = pivot + "&checkout[shipping_address][city]=" + pickupLastName + '&';
        
//         pivot = shippingInformation.replace(/checkout\\[shipping_address\\]\\[province\\](.*?)\\&/ig, '');      	
// 	    shippingInformation = pivot + "&checkout[shipping_address][province]=" + pickupLastName + '&';
        
//         pivot = shippingInformation.replace(/checkout\\[shipping_address\\]\\[address1\\](.*?)\\&/ig, '');      	
// 	    shippingInformation = pivot + "&checkout[shipping_address][address1]=" + pickupLastName + '&';
        
//         pivot = shippingInformation.replace(/checkout\\[shipping_address\\]\\[phone\\](.*?)\\&/ig, '');      	
// 	    shippingInformation = pivot + "&checkout[shipping_address][phone]=" + pickupLastName + '&';
        
//         pivot = shippingInformation.replace(/checkout\\[shipping_address\\]\\[zip\\](.*?)\\&/ig, '');      	
// 	    shippingInformation = pivot + "&checkout[shipping_address][zip]=" + pickupLastName + '&';
        
//         pivot = shippingInformation.replace(/checkout\\[shipping_address\\]\\[company\\](.*?)\\&/ig, '');      	
// 	    shippingInformation = pivot + "&checkout[shipping_address][company]=" + pickupLastName + '&';
	  
// 	  	myForm.attr('action', shippingInformation)  
        
//         var selectedStore = jqCR('#storeUL').val();
      
// 		if (jqCR('#cart-form').valid() && selectedStore != "Select pickup location") {
//            myForm.submit()      	
//         } else {

//         }	  
	    
//       }else{
      
//       }
//   })
	
// });

$('input[name="update"]').on('click tap', function(e){
  e.preventDefault();
  $('#cart-form').off()	
  $('#cart-form').attr('action', '/cart');
  $('#cart-form').submit()	
});

window.onload = function() { 
    jQuery.getJSON('/cart', function(e){
      var items = e.items;
      for (var i in items) {
        if(items[i].title === "Pickup Instore") {
          var tt = setInterval(function(){disableCheckoutButton();}, 1000);
          setTimeout(function() { clearInterval(tt); }, 5000);        	
        }
      }
    })
    
    
  };
document.addEventListener('crPickupActivated', function (e) { 
    console.log('____ activated _____');
    disableCheckoutButton();
    var tt = setInterval(function(){disableCheckoutButton();}, 1000);
    setTimeout(function() { clearInterval(tt); }, 5000);  

  jqCR('#pickup-date-start, #note-pickup-date, #pickup-first-name, #pickup-last-name, #pickup-number').on('mouseout keyup change', function(){
  	//console.log('check for others and activate checkout')  	
    checkPickupFields()
  })
  
  //jqCR(document).on('change', '#pickup-selected-store', function(){checkPickupFields()})  
  //trackChange(jqCR("#pickup-selected-store")[0] );  

  jqCR(document).on('change', '#note-pickup-date', function(){checkPickupFields()})  
  trackChange(jqCR("#note-pickup-date")[0] );
});


MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

var trackChange = function(element) {
  var observer = new MutationObserver(function(mutations, observer) {
    if(mutations[0].attributeName == "value") {
        jqCR(element).trigger("change");
    }
  });
  observer.observe(element, {
    attributes: true
  });
}

function checkPickupFields(){
  	var pickupDate = jqCR('#pickup-date-start').val();
    var firstName = jqCR('#pickup-first-name').val();
    var lastName = jqCR('#pickup-last-name').val();
    var phone = jqCR('#pickup-number').val();
    var selectedStoreId = jqCR('#pickup-selected-store-id').val()
    if (selectedStoreId && pickupDate) {
    	activateCheckoutButton();
    } else {
    	disableCheckoutButton()
    }
}

function activateCheckoutButton(){
    document.querySelector('[name=checkout]').disabled = false;
  }

function disableCheckoutButton(){    
    document.querySelector('[name=checkout]').disabled = true;
}



// window.onload = function() { 
//     jQuery.getJSON('/cart', function(e){
//       var items = e.items;
//       for (var i in items) {
//         if(items[i].title === "Pickup Instore") {
//           var tt = setInterval(function(){disableCheckoutButton();}, 1000);
//           setTimeout(function() { clearInterval(tt); }, 5000);        	
//         }
//       }
//     })
    
    
//   };

// document.addEventListener('crPickupActivated', function (e) { 
//     console.log('____ activated _____');
//     var tt = setInterval(function(){disableCheckoutButton();}, 1000);
//     setTimeout(function() { clearInterval(tt); }, 5000);    
//     disableCheckoutButton();

//   jqCR('#pickup-date-start, #note-pickup-date, #pickup-first-name, #pickup-last-name, #pickup-number').on('mouseout keyup change', function(){
//   	console.log('check for others and activate checkout')  	
//     checkPickupFields()
//   })
  
//   jqCR(document).on('change', '#note-pickup-date', function(){
//   console.log('========== change');
//   checkPickupFields()
// })
// // Just pass an element to the function to start tracking
// trackChange( jqCR("#note-pickup-date")[0] );
  
//   });


// MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

// var trackChange = function(element) {
//   var observer = new MutationObserver(function(mutations, observer) {
//     if(mutations[0].attributeName == "value") {
//         jqCR(element).trigger("change");
//     }
//   });
//   observer.observe(element, {
//     attributes: true
//   });
// }

// // $('#pickup-date-start, #note-pickup-date').on('mouseout keyup change', function(){
// //   	//console.log('check for others and activate checkout')  	
// //     checkPickupFields()
// //   })
  
//   function checkPickupFields(){
//   	var pickupDate = $('#pickup-date-start').val();
//     var firstName = $('#pickup-first-name').val();
//     var lastName = $('#pickup-last-name').val();
//     var phone = $('#pickup-number').val();
//     var selectedStore = jQuery('#storeUL').val();
// console.log(selectedStore);    
//     if (pickupDate && selectedStore != "Click to select pickup location") {
//     	activateCheckoutButton();
//     } else {
//         //
//     	disableCheckoutButton()
//     }
//   }

// function activateCheckoutButton(){
//     console.log('activate!!')
//     $('input[name=checkout]').removeAttr('disabled');
//   }

//   function disableCheckoutButton(){   

//     $('input[name=checkout]').attr('disabled', 'disabled');
//   }